function toTrimmedString(value) {
  if (value === undefined || value === null) return '';
  return String(value).trim();
}

function buildSearchPatternHelpMarkdown() {
  return [
    'Search text used to find the BACnet target for each equipment record.',
    '',
    'How it works:',
    '1. Runs once per equipment record, not once for the full batch.',
    '2. If you use `{Name}`, it is replaced with that equipment name.',
    '3. Matching mode depends on **Search for**:',
    '- **Device Name**: pattern is matched against device names under the selected BACnet Host.',
    '- **Host Name**: pattern is matched against BACnet Host names, then devices are taken from the first matched Host.',
    '- If the template needs multiple devices, the first N devices from that Host are used.',
    '- If fewer than required devices are found, only matched device slots are bound and unmatched slots are skipped.',
    '',
    'Example:',
    '- Pattern: `GCRB - Level-1 - {Name} - East`',
    '- Equipment name: `AHU-03`',
    '- Effective search string: `GCRB - Level-1 - AHU-03 - East`'
  ].join('\n');
}

function buildRestrictServerHelpMarkdown() {
  return [
    'Choose how search is performed.',
    '',
    'Search for = **Device Name**:',
    '- You must select one BACnet Host.',
    '- Search Pattern is matched against device names under that Host.',
    '',
    'Search for = **Host Name**:',
    '- Search Pattern is matched against BACnet Host names.',
    '- Devices are taken from the first matched Host.',
    '- If the template needs multiple devices, the first N devices from that Host are used.',
    '- If fewer than required devices are found, only matched device slots are bound and unmatched slots are skipped.'
  ].join('\n');
}

function buildSelectedServerHelpMarkdown() {
  return [
    'RID of the BACnet Host used when **Search for** is set to **Device Name**.',
    '',
    'Tips:',
    '- You can type a RID directly (format: `#12:0`).',
    '- Or use the browser and click **Use Selected BACnet Host**.',
    '- This field is required only when **Search for** is **Device Name**.'
  ].join('\n');
}

function buildBindingTemplateHelpMarkdown() {
  return [
    'Template name used to resolve class templates during bulk bind.',
    '',
    'Use this when **Pick Template** mode is selected.',
    'If you use **Paste JSON** or **Upload File**, this selector is ignored.'
  ].join('\n');
}

function buildTemplateContentHelpMarkdown() {
  return [
    'Binding template JSON applied to each target equipment.',
    '',
    'Input modes:',
    '- Pick Template: loads JSON from a saved template.',
    '- Paste JSON: paste the full template content manually.',
    '- Upload File: upload a `.json` or `.txt` template file.',
    '',
    'In bulk mode, the same template content is applied to each matching equipment record.'
  ].join('\n');
}

function buildBindingOptionalHelpMarkdown() {
  return [
    'When enabled, the system binds each created equipment record immediately after creation.',
    '',
    'If disabled, the Excel import only creates equipment and skips binding.'
  ].join('\n');
}

var HELP_BY_KEY = {
  applybinding: {
    title: 'Binding (Optional)',
    markdown: buildBindingOptionalHelpMarkdown()
  },
  applybindingaftercreate: {
    title: 'Binding (Optional)',
    markdown: buildBindingOptionalHelpMarkdown()
  },
  bindingtemplate: {
    title: 'Binding Template',
    markdown: buildBindingTemplateHelpMarkdown()
  },
  templatecontent: {
    title: 'Template JSON Content',
    markdown: buildTemplateContentHelpMarkdown()
  },
  restricttoserver: {
    title: 'Search For',
    markdown: buildRestrictServerHelpMarkdown()
  },
  selectedserverrid: {
    title: 'BACnet Host',
    markdown: buildSelectedServerHelpMarkdown()
  },
  searchpattern: {
    title: 'Search Pattern',
    markdown: buildSearchPatternHelpMarkdown()
  }
};

function getBulkBindingFieldHelp(fieldKey) {
  var normalizedKey = toTrimmedString(fieldKey).toLowerCase();
  if (!normalizedKey) return null;
  return HELP_BY_KEY[normalizedKey] || null;
}

module.exports = {
  getBulkBindingFieldHelp: getBulkBindingFieldHelp
};
